import { API_BASE } from "../utils/baseapiurl";

class BoBNotesAPI {
	async request(path, { method = "GET", body } = {}) {
		const response = await fetch(`${API_BASE}${path}`, {
			method,
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": window.wpApiSettings?.nonce || "",
			},
			credentials: "include",
			...(body ? { body: JSON.stringify(body) } : {}),
		});

		const data = await response.json().catch(() => ({}));

		if (!response.ok) {
			throw new Error(data.message || "Something went wrong. Please try again.");
		}

		return data;
	}

	/** Notes for one live BoB row, newest first. */
	getNotes(clientKey) {
		return this.request(`/agent-bob/notes?${new URLSearchParams({ anchor_key: clientKey })}`);
	}

	/** `period` is the cutoff ("YYYY-MM") the note is added from; the server checks the client is in it. */
	createNote(clientKey, note, period = null) {
		return this.request("/agent-bob/notes/create", { method: "POST", body: { anchor_key: clientKey, note, ...(period ? { period } : {}) } });
	}

	updateNote(id, note) {
		return this.request("/agent-bob/notes/update", { method: "POST", body: { id, note } });
	}

	deleteNote(id) {
		return this.request("/agent-bob/notes/delete", { method: "POST", body: { id } });
	}
}

export default new BoBNotesAPI();
